import GeneralHelper from "../../../common/helpers/GeneralHelper";
import CatalogService from "../../../common/services/catalog/CatalogService";
import QuotationService from "../../../common/services/rfp/QuotationService";
import RfpService from "../../../common/services/rfp/RfpService";
import RfpWatchlistService from "../../../common/services/rfp/RfpWatchlistService";
import { FILTER_REQUEST_TRADER, SET_CATALOG } from "../../filter/store/actions";
import GeneralVariables from "../../../common/utils/GeneralVariables";
import {
    OPEN_RFP_DIALOG,
    CREATE_RFP,
    GET_RFPS,
    CREATE_QUOTATION,
    GET_RFP_QUOTATIONS,
    RFP_INC_VIEWS,
    CREATE_RFP_WATCHLIST_RECORD,
    GET_RFP,
    CREATE_GUEST_RFP,
    RFP_REQUEST,
    DIALOG_SET_RQUEST_ID,
    RFP_DIALOG_SET_EDIT_MODE,
    CLOSE_RFP_DIALOG,
    GET_RFP_CATALOG,GET_LATEST_RFP, 
    RFP_CHAT_AI,
    RFP_CHAT_AI_STATUS,
    RFP_FILTER_REQUEST_TRADER,
    RESET_RFP_FILTER_REQUEST_TRADER,
    GET_MATCHING_KITS
} from "./actions";
import { GET_CUSTOMER_REQUESTS } from "../../userdashboard/store/rfp/actions";

export default {
    state: {
        matchingKits: [],
        showRfpDialog: false,
        rfps: [],
        traderRfps: [],
        canRfpPaginate: true,
        showRfpDetailsDialog: false,
        rfpDetailsData: { id:0, rfp_content:
            { currency: {}, budget: [] }},
        showRfpShare: false,
        editMode: false,
        editRfpId: null,
        rfpActiveComponent: "OffersSection",
        latestRFP:[],
        rfpChat:[],
        rfpChatStatus:"start",
        soldRfpDetails:{
            brands: [],
            products: [],
            categories: [],
            conditions: [],
            title:"",
            description:"",
            budget:[],
            currency:null,
        },
    
    },
    getters: {
        matchingKits:(state) =>
        {
            return state.matchingKits
        },
        showRfpDialog: (state) => state.showRfpDialog,
        soldRfpDetails: (state) => state.soldRfpDetails,
        rfpsList: (state) => state.rfps,
        traderRfpsList: (state) => state.traderRfps,
        showRfpDetailsDialog: (state) => state.showRfpDetailsDialog,
        rfpDetailsData: (state) => state.rfpDetailsData,
        showRfpShare: (state) => state.showRfpShare,
        editMode: (state) => state.editMode,
        editRfpId: (state) => state.editRfpId,
        rfpActiveComponent: (state) => state.rfpActiveComponent,
        latestRFP: (state) => state.latestRFP,
        rfpChat: (state) =>  state.rfpChat,
        rfpChatStatus: (state) =>  state.rfpChatStatus,
        
    },
    mutations: {
        [DIALOG_SET_RQUEST_ID]: (state, id) => {
            state.editRfpId = id;
        },
        ["SET_SOLD_RFP_DETAILS"]: (state, soldRfpDetails) => {
            state.soldRfpDetails = soldRfpDetails;
        },
        [GET_LATEST_RFP]: (state,data) => {
            
            state.latestRFP = data;
        },
        [RFP_DIALOG_SET_EDIT_MODE]: (state, data) => {
            state.editMode = data;
        },
        rfpActiveComponent: (state, data) => {
            state.rfpActiveComponent = data;
        },
        [OPEN_RFP_DIALOG]: (state) => {
            state.showRfpDialog = true;
        },
        [CLOSE_RFP_DIALOG]: (state) => {
            state.showRfpDialog = false;
        },
        [GET_RFP_CATALOG]: (state, catalog) => {
            state.brands = catalog.brands;
            state.categories = catalog.categories;
            state.products = catalog.products;
            state.conditions = catalog.conditions;
        },
        [GET_RFPS]: (state, data) => {
            state.rfps = data;
        },
        [RFP_FILTER_REQUEST_TRADER] : (state, traderRfps)=> {
            let newTraderRfps = state.traderRfps.slice()
            for(let i =0; i<traderRfps.length; i++)
                {
                    if (!newTraderRfps.some(e => e.id === traderRfps[i].id))
                    {
                        newTraderRfps.push(traderRfps[i])
                    }
                }
                state.traderRfps = newTraderRfps

        },
        [RESET_RFP_FILTER_REQUEST_TRADER]: (state) => {
            state.traderRfps = [];
        },
        [GET_RFP_QUOTATIONS]: (state, data) => {
            state.rfps.forEach((item) => {
                if (item.id == data.id) item.quotations = data.quotations;
            });
        },
        toggleRfpDetailsDialog(state, data) {
            state.showRfpDetailsDialog = !state.showRfpDetailsDialog;
            state.rfpDetailsData = data;
        },
        toggleShowRfpShare(state) {
            state.showRfpShare = !state.showRfpShare;
        },
        [RFP_CHAT_AI]: (state, chat) => {
            state.rfpChat = chat;
        },
        [RFP_CHAT_AI_STATUS]: (state, status) => {
            state.rfpChatStatus = status;
        },
        [GET_MATCHING_KITS]: (state, data) => {
            state.matchingKits = data;
        },
    
    },

    actions: {
        [GET_MATCHING_KITS]: async(context, id) => {
            let rfpService = new RfpService()
            let result = await rfpService.getMatchingKits(id)
            context.commit(GET_MATCHING_KITS, result.data.data??[])
            return result
        },
        [RFP_CHAT_AI]: async(context, data) => {
            var rfpService = new RfpService();
            let data1 = {
                chat:data.chat,
                current_step:context.getters.rfpChatStatus,
                signal: data.signal,
            }

            var res = await rfpService.createFromChatStream(data1);

            let reader = res.body.getReader();
            let decoder = new TextDecoder('utf8');
            let result;
            while (!result?.done) {
                result = await reader.read();
                let chunk = decoder.decode(result.value);
                if (!chunk) break
                var sanitized = '[' + chunk.replace(/}{/g, '},{') + ']';
                let json = JSON.parse(sanitized)

                json = json[json.length - 1]

                context.commit(RFP_CHAT_AI, json.data.chat)
                context.commit(RFP_CHAT_AI_STATUS, json.data.current_step)
            }

            
            if (context.getters.rfpChatStatus == 'process_rfp')
            {
                let data1 = {
                    chat:context.getters.rfpChat.slice(),
                    current_step:context.getters.rfpChatStatus,
                    signal: data.signal
                }
                let chat = context.getters.rfpChat.slice()
                chat.push({role:"assistant", content:``, is_processing:true})
                context.commit(RFP_CHAT_AI, chat)

                var res = await rfpService.createFromChatStream(data1);

                reader = res.body.getReader();
                decoder = new TextDecoder('utf8');
                result = undefined;
                while (!result?.done) {
                    result = await reader.read();
                    let chunk = decoder.decode(result.value);
                    if (!chunk) break
                    var sanitized = '[' + chunk.replace(/}{/g, '},{') + ']';
                    let json = JSON.parse(sanitized)
                    json = json[json.length - 1]
                    chat = json.data.chat
                    chat.push({role:"assistant", content:`Your Request is ready. Go to ${GeneralVariables.URL + 'en/post-request/edit/' + json.data.rfp.id}` })
                    context.commit(RFP_CHAT_AI, chat)
                    context.commit(RFP_CHAT_AI_STATUS, json.data.current_step)
                }

                
            }
            return result;
        },
        rfpActiveComponent(context, data) {
            context.commit("rfpActiveComponent", data);
        },
        [GET_RFP_QUOTATIONS]: async(context, id) => {
            var rfpService = new RfpService();
            var result = await rfpService.getQuotations(id);
            context.commit(GET_RFP_QUOTATIONS, {
                id: id,
                quotations: result.data.data,
            });
            return result;
        },
        [GET_LATEST_RFP]: async(context) => {
            var rfpService = new RfpService();
            var result = await rfpService.latestRFP();
            context.commit(GET_LATEST_RFP,
                result.data.data.rfps.data ,
            );
            context.commit('addToTranslations',result.data.data.translations)
            return result;
        },

        [CREATE_QUOTATION]: async(context, data) => {
            var quotationService = new QuotationService();
            var result = await quotationService.create(data, { authorization: true });
            return result;
        },

        [GET_RFPS]: async(context) => {
            var rfpService = new RfpService();
            var result = await rfpService.get();
            context.commit(GET_RFPS, result.data.data);
            return result;
        },

        [OPEN_RFP_DIALOG]: (context) => {
            context.commit(OPEN_RFP_DIALOG);
        },
        [CLOSE_RFP_DIALOG]: (context) => {
            context.commit(CLOSE_RFP_DIALOG);
        },
        [GET_RFP_CATALOG]: async(context, catalog) => {
            var catalogService = new CatalogService();
            var catalog = await catalogService.get();
            context.commit(GET_RFP_CATALOG, catalog);
        },
        [CREATE_RFP]: async(context, rfp) => {
            var rfpService = new RfpService();
            if (!Array.isArray(rfp.budget)) rfp.budget = rfp.budget._value;
            if (!Array.isArray(rfp.year)) rfp.year = rfp.year._value;
            var result = await rfpService.create({ rfp: rfp }, {
                message: {
                    success: GeneralHelper.buildMessage(
                        1,
                        "Thank you for placing a new request !"
                    ),
                },
            });
            await context.dispatch(GET_CUSTOMER_REQUESTS);
            return result;
        },
        [CREATE_GUEST_RFP]: async(context, rfp) => {
            var rfpService = new RfpService();
            if (!Array.isArray(rfp.budget)) rfp.budget = rfp.budget._value;
            if (!Array.isArray(rfp.year)) rfp.year = rfp.year._value;
            var result = await rfpService.guestCreate({ rfp: rfp }, {
                message: {
                    success: GeneralHelper.buildMessage(
                        1,
                        "Thank you for placing a new request !"
                    ),
                },
            });
            await context.dispatch(GET_CUSTOMER_REQUESTS);
            return result;
        },
        toggleRfpDetailsDialog(context, data) {
            context.commit("toggleRfpDetailsDialog", data);
            if (context.getters.showRfpDetailsDialog == true) {
                context.dispatch(RFP_INC_VIEWS, context.getters.rfpDetailsData.id);
            }
        },
        [RFP_INC_VIEWS]: async(context, id) => {
            var rfpService = new RfpService();
            var result = await rfpService.views(id);
            return result;
        },
        [RFP_REQUEST]: async(context) => {
            context.state.canRfpPaginate = false
            var rfpService = new RfpService();
            var data = {
                brands: JSON.stringify(context.getters.filters.brands),
                products: JSON.stringify(context.getters.filters.products),
                categories: JSON.stringify(context.getters.filters.categories),
                conditions: JSON.stringify(context.getters.filters.conditions),
                specs: JSON.stringify(context.getters.filters.specs),
                minPrice: context.getters.filters.minPrice,
                maxPrice: context.getters.filters.maxPrice,
                minYear: context.getters.filters.minYear,
                maxYear: context.getters.filters.maxYear,
                ccode: context.getters.currency.code,
                page: context.getters.filterPagination.currentPage,
                search: context.getters.filters.search,
                cat_id: context.getters.filters.cat_id,
            };
            
            await rfpService.changeStatusOfExpired()
            rfpService.filter(data, context.getters.isAuthenticated).then(
                async (response)=>{
                    context.commit(GET_RFPS, response.data.data.rfps.data);
                    context.commit(RFP_FILTER_REQUEST_TRADER, response.data.data.rfps.data)
                    console.log(context.state.traderRfps)
                    context.commit('addToTranslations',response.data.data.translations)
                    context.commit("setFilterPagination", response.data.data.rfps);
                    context.state.canRfpPaginate = true
                }
            );
           

            rfpService.filterBrands(data).then(
                (response)=>{
                    context.commit('setBrands', response.data.data);
                }
            );

            rfpService.filterCategories(data).then(
                (response)=>{
                    context.commit('setCategories', response.data.data);
                }
            );

            rfpService.filterMaxPrice(data).then(
                (response)=>{
                    context.commit('setMaxPrice', response.data.data);
                }
            );

            rfpService.filterMinPrice(data).then(
                (response)=>{
                    context.commit('setMinPrice', response.data.data);
                }
            );
            
        },
        [GET_RFP]: async(context, id) => {
            var rfpService = new RfpService();
            var result = await rfpService.findById(id);
            return result;
        },
        [CREATE_RFP_WATCHLIST_RECORD]: async(context, rfpId) => {
            var watchlistService = new RfpWatchlistService();
            var result = await watchlistService.create({
                rfp_id: rfpId,
                customer_id: context.getters.customer.id,
            }, {
                message: {
                    success: GeneralHelper.buildMessage(1, "Added to watchlist"),
                },
            });
            return result;
        },
    },
};